<template>
    <div class="col-lg-7 col-md-7">
        <div class="row">
            <div class="col-lg-8">
                <div class="form-group">
                    <label for="nameEstInput">Invoice Name <small>(Optional)</small></label>
                    <input type="text" :class="['form-control', disabledSteps.customer ? 'disabled' : '']"
                        :disabled="disabledSteps.customer" id="nameEstInput" maxlength="60" v-model="document_name"
                        placeholder="Document name" @change="updateDataForm" />
                </div>
                <div class="form-group showtooltip">
                    <!--
                    <textarea
                        v-model="job_information"
                        id="job_information"
                        :class="['form-control', disabledSteps.customer ? 'disabled' : '']"
                        maxlength="200"
                        :disabled="!jobinfomationcheck || disabledSteps.customer"
                        :placeholder="jobinfomationtitle+': '+((jobinfomationcheck) ? 'Let your client know what this Invoice is for:' : 'Field disabled, set in settings')"
                        @change="updateDataForm"
                    ></textarea>
                    <span class="maxSize">
                        {{ job_information ? job_information.length : 0 }}/200
                    </span>
                    -->
                    <!-- @keydown.enter.prevent="noEnter" -->
                    <editor-job-info :value="job_information" :limit="numberWords" :limitType="'words'"
                        :placeholder="'Let your client know what this Invoice is for:'"
                        :readonly="disabledSteps.customer" :editorClass="'form-control job_information_invo'"
                        @input="updateDataForm" :emitOnLimitReached="true"></editor-job-info>
                </div>
            </div>
            <date-doc-due-terms :propdate="dateDoc" :propdue_date="due_date"
                :proptermsList="termsList" :propterm_id="term_id" @updateDates="getProps" />
        </div>
    </div>
</template>

<script>
import dateDocDueTerms from './dateDocDueTerms.vue';
import RichTextEditor from './../../RichTextEditor.vue'
export default {
    components: {
        "date-doc-due-terms": dateDocDueTerms,
        "editor-job-info": RichTextEditor,
    },
    props: [
        "controlLoad",
        "propdisabledSteps",
        "propdocument_name",
        "propjob_information",
        "propfecdoc",
        "propfecdue",
        "propForm",
    ],
    data() {
        return {
            disabledSteps: this.propdisabledSteps,
            document_name: this.propdocument_name,
            job_information: this.propjob_information,
            dateDoc: this.propfecdoc,
            due_date: this.propfecdue,
            form: this.propForm,
            jobinfomationcheck: true, // Consider starting as null or false if you expect it to be updated from API
            jobinfomationtitle: "Job information",
            term_id: 0,
            termsList: [],
            numberWords: 50,
        }
    },
    created() {
        console.log('props: propfecdoc y propfecdue', this.propfecdoc, this.propfecdue);
        this.getInvoiceSetting();
        this.getKeyValSetting('job_information_numberWords', 50).then((resul) => {
            this.numberWords = parseInt(resul);
        });
    },
    methods: {
        getKeyValSetting (meta_key, valueDefault) {
            return new Promise((resolve, reject) => {
                try{
                    window.billing
                    .post('getKeyValSetting', {
                        user_id: window.master_client,
                        org_id: window.localorgdata,
                        meta_key: meta_key,
                    })
                    .then((response) => {
                        // console.log(meta_key, response.data);
                        resolve(response.data.status ? response?.data?.r?.meta_value : valueDefault);
                    });
                }catch(e){
                    resolve(valueDefault);
                    reject(valueDefault);
                }
            });
        },
        updateDataForm(data_job_information) {
            data_job_information = (data_job_information == null || data_job_information == undefined) ? this.job_information : data_job_information;
            data_job_information = (typeof data_job_information == 'string') ? data_job_information : "";
            // console.log('updateDataForm job_information', data_job_information)
            this.$emit('updateProps', {
                document_name: this.document_name,
                job_information: data_job_information,
                term_id: this.term_id,
                dateDoc: this.dateDoc,
                due_date: this.due_date,
            });
        },
        getProps(data) {
            this.dateDoc = data.dateDoc;
            this.due_date = data.due_date;
            this.term_id = data.term_id;
            this.updateDataForm(this.job_information);
        },
        noEnter(e) {
            return false
        },
        getTermsList() {
            this.$emit('loadingData', { name: 'getTermsList', status: 'pending' });
            window.billing
                .get("terms/" + window.localuserdata)
                .then((response) => {
                    if (response.data.length) {
                        this.termsList = response.data;
                        // console.log('termsList', this.termsList);
                    }
                    this.$emit('loadingData', { name: 'getTermsList', status: 'finish' });
                    this.updateDataForm(this.job_information);
                })
                .catch((error) => {
                    console.log(error);
                    this.$emit('loadingData', { name: 'getTermsList', status: 'error' });
                });
        },
        getInvoiceSetting() {
            this.$emit('loadingData', { name: 'getInvoiceSetting', status: 'pending' });
            window.billing
                .get("invoice/setting/" + window.localuserdata)
                .then((response) => {
                    if (response.data.result.length) {
                        let r = response.data.result[0];
                        this.jobinfomationcheck = r.jobinfomationcheck;
                        this.jobinfomationtitle = r.jobinfomationtitle;
                        if (this.form.actionNname == "create") {
                            this.job_information = r.jobinfomationtext;
                            this.term_id = r.term_id;
                        }
                    }
                    this.$emit('loadingData', { name: 'getInvoiceSetting', status: 'finish' });
                    this.getTermsList();
                })
                .catch((error) => {
                    console.log(error);
                    this.$emit('loadingData', { name: 'getInvoiceSetting', status: 'error' });
                });
        },
    },
    watch: {
    },
};
</script>
<style>
.job_information_invo,
.quillWrapper.job_information_invo {
    margin: -0.375rem -0.75rem;
    width: 100%;
    min-width: 360px;
    min-height: 135px;
    max-height: 135px;
    height: auto;
    overflow: hidden;
    overflow-y: auto;
}

@media (max-width: 370px) {
    .job_information_invo {
        min-width: 100%;
    }

}
</style>
